<template>
    <div>
        <FormVueSelect append-to-bodyx hide-errors multiple :searchable="true" v-model="selectedValues" max-height="200" class="!tw-h-fitx"
            :options="products" option-value="id" :label="$t('fields.product')" :error="errors.product_id &&
                $t('errors.' + errors.product_id, {
                    field: $t('fields.product'),
                })
                ">
            <template v-slot:option="{ option }">
                <p class="tw-p-2 tw-rounded tw-text-xs tw-px-4">{{
                    option.name }}</p>
            </template>
            <template v-slot:selected-option-container="{ params }">
                <div class="vs__selected tw-text-xs tw-py-0 tw-px-2" :class="params.option.color" @click="removeValue(params.option.id)">
                    <p class="tw-max-w-[90px] tw-truncate">{{ params.option.label }}</p>
                    </div>
            </template>
        </FormVueSelect>
    </div>
</template>

<script setup>
import FormVueSelect from "@/components/form/FormVueSelect";
import { computed, ref, watch, inject } from 'vue';
// import { useI18n } from "vue-i18n";
import { useStateStore } from '@/stores/app/state';

// const i18n = useI18n();
const updateFilters = inject('update:filters')
const filters = inject('filters')
const stateStore = useStateStore();
const products = computed(() => [...stateStore.products.map(p => ({ ...p, label: p.name }))]);

const errors = ref({})
const selectedValues = ref(filters.value.product_id);

watch(() => selectedValues.value, () => {
    const newFilters = {
        ...filters.value,
        product_id: selectedValues.value,
    }

    updateFilters(newFilters)
})

const removeValue = value => {
    selectedValues.value = selectedValues.value.filter(v => v != value)
}

</script>

<style></style>